<template>
  <v-bottom-navigation
    v-show="toggle"
    active-class="active primary--text"
    class="m-nav background elevation-1 pt-1"
  >
    <v-btn
      v-for="(page, key) in pages"
      :key="'btn-'+key"
      :to="page.route"
      exact
      icon
      tile
      color="transparent"
      class="btn"
    >
      <v-icon>{{ page.icon }}</v-icon>
    </v-btn>
    <v-menu 
      bottom
      offset-y
      open-delay="250"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          tile
          color="transparent"
          class="btn menu white--text"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>{{ icons.menu }}</v-icon>
        </v-btn>
      </template>
      <v-list
        nav
        color="black"
        min-width="60vw"
        class="menu-navbar rounded-lg"
      >
        <v-list-item
          v-for="(item, index) in links"
          :key="index"
          @click="goTo(item.route)"
          class="px-3"
        >
          <v-list-item-icon class="mr-6">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-body-1">{{ $t(item.title) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-bottom-navigation>
</template>

<style lang="scss">
  #app .m-nav {
    // position: sticky !important;
    // position: absolute !important;
    // top: calc(56px + var(--safe-area-top)) !important;
    // bottom: auto !important;
    // z-index: 5;
    // background-color: var(--v-background-base) !important;
    // height: calc(56px + var(--safe-area-bottom)) !important;
    // padding: 0 0 var(--safe-area-bottom) var(--safe-area-left) !important;
    border-top: 1px solid var(--v-secondary-darken4) !important;
    .btn {
      min-width: auto !important;
      width: 100%;
      height: 100%;
      &:hover::before {
        opacity: 0 !important;
      }
      &.menu {
        color: white !important;
      }
    }
  }
  .menu-navbar {
    .v-list-item--active {
      color: var(--v-primary-base) !important;
    }
  }
</style>

<script>
  import { 
    mdiMenu
  } from '@mdi/js';

  export default {
    props: {
      toggle: {
        type: Boolean,
        default: true
      },
      pages: {
        type: Object,
        default: () => {}
      },
      menu: {
        type: [Array, Object],
        default: () => []
      },
      user: {
        type: Object,
        default: () => {}
      }
    },
    data: () => ({
      icons: {
        menu: mdiMenu
      }
    }),
    computed: {
      links () {
        const profile = this.user.profile;
        return this.menu.filter(page => !('partner' in page)||page.partner==profile?.partner);
      },
    },
    methods: {
      goTo (route) {
        setTimeout(() => {
          this.$router.push(route);
        }, 250);
      }
    },
  }
</script>